/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

	      // Navbar shrink
				$(window).scroll(function() {
					if ($(document).scrollTop() > 38) {
						$('.navbar').addClass('navbar-shrink');
					} else {
						$('.navbar').removeClass('navbar-shrink');
					}
				});

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

				// Smooth scroll to div
				$(function() {
					$('a[href*=\\#]:not([href=\\#])').click(function() {
						if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
							var target = $(this.hash);
							target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
							if (target.length) {
								if (window.innerWidth > 767) {
									$('html,body').animate({
											scrollTop: target.offset().top - 50
									}, 500);
									return false;
								} else {
									$('html,body').animate({
											scrollTop: target.offset().top
									}, 500);
									return false;
								}
							}
						}
					});
				});

        // Show/hide element for email-before-download form
        $(document).ready(function () {
          $("#featured-link-show-hide").click(function () {
            // $("#featured-link-email-form").toggle();
            $("#featured-link-email-form").toggleClass("open");
          });
          $("#featured-product-show-hide").click(function () {
            // $("#featured-product-email-form").toggle();
            $("#featured-product-email-form").toggleClass("open");
          });
        });

        // Replace MailChimp success message with something appropriate for the download Form
        $('#featured-link-email-form #mce-success-response').bind('DOMSubtreeModified', function(e) {
          document.getElementById("mce-success-response").textContent="Thank you! Please check your email for a link to your download.";
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Post type singles
    'single': {
      init: function() {
        // JavaScript to be fired on post type singles

        // Floating share buttons
				$(window).scroll(function() {
          var buttonsScrollTop = $(window).scrollTop(),
              buttonsDistDocTop = $('.floating-share-buttons').offset().top,
              headerDistDocTop = $('.page-header').offset().top,
              headerHeight = $('.page-header').height(),

              buttonsDistWinTop = ( buttonsDistDocTop - buttonsScrollTop ),
              buttonsDistHeader = ( buttonsDistDocTop - ( headerDistDocTop + headerHeight ) );

          if ( ( buttonsDistWinTop <= 100 ) && ( buttonsDistHeader >= 110 ) && ( $(document).scrollTop() < $(document).height() - 1000 ) ) {
            $('.floating-share-buttons').addClass('share-float');
          }
          else {
						$('.floating-share-buttons').removeClass('share-float');
					}
				});
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
